var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var borderRadius = {
    sm: 2,
    md: 4,
    lg: 4,
};
export function getBorderRadius(size) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", "px;\n  "], ["\n    border-radius: ", "px;\n  "])), borderRadius[size]);
}
var templateObject_1;
//# sourceMappingURL=borderRadius.js.map